module.exports = function getResource(label, vars = []) {
    let resources = {
        joinButton: 'S’inscrire',
        createAccount: 'Créer un compte'
    };

    return resources[label];
};
